/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import EnvBanner from '@components/ui/Banner/EnvBanner';
import { Page } from '@components/ui/Page';
import React, { FC, PropsWithChildren, useState } from 'react';

export type PageState = object;

export const PageContext = React.createContext<PageState>({} as PageState);
PageContext.displayName = 'PageContext';

type PageProps = PropsWithChildren<object>;

export const PageWrapper: FC<PageProps> = ({ children }) => {
  const [state] = useState<PageState>({});

  return (
    <PageContext.Provider value={state}>
      <Page>
        {/* Environment banner */}
        {process.env.NODE_ENV === 'development' && <EnvBanner />}

        {children}
      </Page>
    </PageContext.Provider>
  );
};

export default PageContext;
